import script from "./PublicDatasets.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicDatasets.vue?vue&type=script&setup=true&lang=js"

import "./PublicDatasets.vue?vue&type=style&index=0&id=0204a187&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0204a187"]])

export default __exports__